export const COMPANY = {
  id: "395f5bef-f16e-4b04-a777-416abd4e7f8c",
  name: "Advanced Fleet Signs",
  description: "All your fleet management needs in one place.",
  domain:
    process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
      ? "afsigns.com.au"
      : process.env.NEXT_PUBLIC_ENVIRONMENT === "development"
        ? "dev.afsigns.com.au"
        : null,
  email: "sales@afsigns.com.au",
  phone: "+61894561414",
  address: {
    street: "16 Brewer Rd",
    city: "Canning Vale",
    state: "WA",
    postcode: "6155",
    country: "Australia",
  },
  abn: "57157918011",
  taxID: "GST",
  logo: "https://res.cloudinary.com/djowccubk/image/upload/v1736489816/logos/adlhrku0wmrheyjiwgha.png",

  timezone: 8, // Perth timezone offset from UTC

  //Work hours
  workHours: "Mon - Fri: 8:00 AM - 4:00 PM",
  publicHolidays: "Closed on Public Holidays",

  //Banking Details
  bankName: "ANZ Bank",
  bankBSB: "016-286",
  bankAccount: "186119033",

  googleReview: "https://g.page/r/Cdpsocztj4O7EAI/review",
};

export const SHIPPING_COMPANIES = {
  name: "MyPostBusiness",
  url: "https://shippingaustralia.com.au",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/advancedfleetsigns",
  twitter: "https://www.twitter.com/advfleetsigns",
  instagram: "https://www.instagram.com/advancedfleetsigns",
  linkedin: "https://www.linkedin.com/company/afsigns",
};

//only verified company emails
export const EMAILS = {
  //Sent to client
  verification: "verify@afsigns.com.au",
  passwordReset: "reset@afsigns.com.au",
  website: "website@afsigns.com.au",
  warranty: "warranty@afsigns.com.au",
  sales: "sales@afsigns.com.au",

  //Internal Emails
  owner: "damien@afsigns.com.au",
  developer: "developer@afsigns.com.au",
  marketing: "marketing@afsigns.com.au",

  support: "support@afsigns.com.au",
};

export const COLOURS = {
  primary: "#fd6f0e",
  secondary: "#fd5900",
  success: "#10b981",
  muted: "#6b7280",
};

export const UI = {
  emailPlaceholder: "Enter your email",
  firstNamePlaceholder: "Enter your first name",
  lastNamePlaceholder: "Enter your last name",
  passwordPlaceholder: "Enter your password",
  confirmPasswordPlaceholder: "Confirm your password",
  phonePlaceholder: "Enter your contact number",

  googleMapsLink: "https://maps.app.goo.gl/mfg4pEYYvxHsT2Tc7",
  coordinates: "-32.06325055886422, 115.91268655742262",
};

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  SETTINGS: "/settings",
} as const;

export const API_ROUTES = {
  AUTH: "/api/auth",
  USERS: "/api/users",
  PROFILE: "/api/profile",
} as const;

export const DEFAULT_PAGINATION = {
  PAGE_SIZE: 10,
  PAGE: 1,
} as const;

export const MESSAGES = {
  ERRORS: {
    UNAUTHORIZED: "You must be logged in",
    FORBIDDEN: "You don't have permission",
    NOT_FOUND: "Resource not found",
    VALIDATION: "Invalid input",
  },
  SUCCESS: {
    CREATED: "Successfully created",
    UPDATED: "Successfully updated",
    DELETED: "Successfully deleted",
  },
} as const;

// Environment helper functions
export const isDevelopmentEnvironment = () => {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === "development";
};

export const isProductionEnvironment = () => {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
};

export const isLocalEnvironment = () => {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === "local";
};

// Helper to determine if navigation should be hidden
export const shouldHideNavigation = () => {
  return isDevelopmentEnvironment();
};
